import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FactoryIcon from "@mui/icons-material/Factory";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import { RUTA_ANALISIS_FINANZAS, RUTA_ANALISIS_OPERACIONES } from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_ANALISIS_FINANZAS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={AttachMoneyIcon}
                    ruta={RUTA_ANALISIS_FINANZAS}
                    titulo="Finanzas"
                    descripcion="Informes financieros y métricas."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_ANALISIS_OPERACIONES) && (
                <CardCol>
                  <MenuItemCard
                    Icono={FactoryIcon}
                    ruta={RUTA_ANALISIS_OPERACIONES}
                    titulo="Operaciones"
                    descripcion="Indicadores operativos y rendimiento."
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;
